

















import Vue from "vue";
import { mapGetters } from "vuex";

//Model
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    data() {
        return {
            folderName: null,
            createBranch: false,
            branchGln: null,
            branchLocation: null,
        };
    },
    props: ["createFolderIn"],
    computed: {
        ...mapGetters(["folderIdsAndNames", "authUserHasPrivilege"]),

        createFolderInName() {
            var folderObj = this.folderIdsAndNames.find((c) => c.id == this.createFolderIn);
            return folderObj ? folderObj.name : "";
        },
        createBranchEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.BranchesManagement);
        },
    },
    watch: {
        createFolderIn() {
            this.folderName = null;
        },
    },
    methods: {
        reset() {
            this.folderName = null;
            this.createBranch = false;
            this.branchGln = null;
            this.branchLocation = null;
        },
        saveNewFolder() {
            this.$emit("save-new-folder", {
                createInId: this.createFolderIn,
                newFolderName: this.folderName,
                createBranch: this.createBranch,
                branchGln: this.branchGln,
                branchLocation: this.branchLocation,
            });
            this.$emit("close");
            this.reset();
        },
        close() {
            this.$emit("close");
            this.reset();
        },
    },
});
